var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonConverter } from "json2typescript";
import moment from 'moment';
export class MomentConverter {
    static getConverter(dateFormat) {
        switch (dateFormat) {
            case 'ISO_DATE':
                return DateMomentConverter;
            case 'ISO_DATETIME':
                return DateTimeMomentConverter;
            default:
                throw "Can't match converter";
        }
    }
}
let DateMomentConverter = class DateMomentConverter {
    serialize(data) {
        return data.format('YYYY-MM-DD');
    }
    deserialize(data) {
        if (typeof (data) === 'undefined' || data == null) {
            return undefined;
        }
        let date = moment(data, 'YYYY-MM-DD');
        if (date.isValid()) {
            return date;
        }
        throw { message: "Invalid Date" };
    }
};
DateMomentConverter = __decorate([
    JsonConverter
], DateMomentConverter);
let DateTimeMomentConverter = class DateTimeMomentConverter {
    serialize(data) {
        return data.toISOString();
    }
    deserialize(data) {
        if (typeof (data) === 'undefined' || data == null) {
            return undefined;
        }
        let date = moment(data, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
        if (date.isValid()) {
            return date;
        }
        throw { message: "Invalid Date" };
    }
};
DateTimeMomentConverter = __decorate([
    JsonConverter
], DateTimeMomentConverter);
//# sourceMappingURL=moment-convertor.js.map